import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { getHtmlDirStorageKey } from '@app/@core/services/language.service';
@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'numberTranslate',
  standalone: false,
})
export class NumberTranslatePipe implements PipeTransform {
  numbersObject: { [x: string]: string } = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠',
  };

  transform(n: number | string | null | undefined): string {
    if (n === null || n === undefined) return '';
    n = n + '';
    let translatedNumber = '';
    if (localStorage.getItem(getHtmlDirStorageKey()) === 'rtl') {
      for (let i = 0; i < n.length; i++) {
        if (this.numbersObject[n.charAt(i)])
          translatedNumber += this.numbersObject[n.charAt(i)];
        else translatedNumber += n.charAt(i);
      }
    } else translatedNumber = String(n);
    return translatedNumber;
  }
}
